var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3245 4306 c-294 -58 -545 -258 -654 -525 -52 -125 -65 -194 -65 -341 0 -147 13 -216 65 -341 91 -223 294 -412 524 -488 123 -41 221 -55 335 -47 394 25 708 289 806 676 26 104 26 297 0 400 -84 329 -314 563 -641 652 -93 25 -277 32 -370 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 3985 c-233 -46 -436 -214 -526 -435 -170 -419 88 -890 534 -976 387 -74 763 184 838 574 64 333 -120 670 -436 798 -127 51 -277 66 -410 39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2353 c-325 -33 -690 -158 -916 -314 -95 -66 -210 -188 -251 -265 -54 -101 -63 -161 -63 -421 l0 -233 749 0 749 0 4 148 c7 197 41 303 151 467 84 126 327 329 480 401 20 10 37 21 37 25 0 4 -35 22 -77 39 -292 122 -612 179 -863 153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3265 2234 c-16 -2 -66 -9 -110 -15 -223 -29 -499 -112 -705 -210 -345 -165 -554 -384 -601 -633 -5 -27 -9 -167 -9 -312 l0 -264 1561 0 1561 0 -4 298 c-5 327 -6 336 -78 470 -156 291 -624 547 -1175 642 -114 20 -371 34 -440 24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.804f87aa45ae39e8aedbfbddd51dd483.svg";
export { ForwardRef as ReactComponent };